/* @flow */

import {useQuery} from '@apollo/react-hooks';

import type {
    GetContactsSearchResults as GetContactsSearchResultsQuery,
    GetContactsSearchResultsVariables as GetContactsSearchResultsQueryVariables,
} from 'nutshell-graphql-types';

import GET_CONTACTS_SEARCH_RESULTS from '../queries/get-contacts-search-results.graphql';

export const useGetContacts = (
    query: ?string
): ({
    isLoading: boolean,
    contacts: Object[],
    refetch: () => Promise<*>,
    fetchMore: (searchTerm: ?string) => Promise<*>,
}) => {
    const {data, loading, refetch, fetchMore} = useQuery<
        GetContactsSearchResultsQuery,
        GetContactsSearchResultsQueryVariables,
    >(GET_CONTACTS_SEARCH_RESULTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            query,
            limit: 20,
        },
        notifyOnNetworkStatusChange: true,
    });

    const search = data ? data.search : null;
    const quickResults = search ? search.quickResults : null;

    const contactResults = quickResults ? quickResults.contactResults : [];

    return {
        contacts: contactResults,
        isLoading: loading,
        refetch,
        fetchMore: (searchTerm: ?string) => {
            // $FlowIgnore
            return fetchMore({
                query: GET_CONTACTS_SEARCH_RESULTS,
                variables: {
                    query: searchTerm,
                    limit: 20,
                },
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;

                    return {
                        search: {
                            __typename: 'SearchResultItemConnection',
                            ...fetchMoreResult.search,
                        },
                    };
                },
            });
        },
    };
};
